import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Field} from 'formik';
import ColorField from '../../../../../components/product/color/colorfield';
import SelectBox from '../../../../../components/formik/SelectBox';
import InputBox from '../../../../../components/formik/InputBox';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Select from 'react-select';
import {
  isSkinHealthScoreValid,
  rangeStyle,
  scoreRanges,
} from '../../../../../utils/skincareUtils';
import {toast} from 'react-toastify';
import TextareaBox from '../../../../../components/formik/TextareaBox';
import skinDetectionCategories from '../../../../../utils/config/skinDetectionCategories';
import langUtils from '../../../../../utils/langUtils';

export default function SkinReport({formikProps, width}) {
  const categories = skinDetectionCategories
    .getSkinDetectionCategories()
    .filter(s => s.disabled === false);

  return (
    <>
      <h3 className="kt-margin-b-20">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.report">
          Skin Report
        </Trans>
      </h3>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.body">Body</Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field name="body.backgroundColor" component={ColorField} />
        </div>
      </div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.settings">
          Result Page Settings
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.report.title">
          Report Title
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.titleTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.timestamp">
          Timestamp
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.enableTimestamp"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.enableTimestamp'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.timestampTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.age">
          Skin Age
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.skinAge.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.skinAge.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinAge.titleTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.score.text.color">
            Score Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinAge.scoreTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.health">
          Skin Health
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.skinHealth.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.skinHealth.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.titleTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.score.text.color">
            Score Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.scoreTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.health.comment">
          Skin Health Comment
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.skinHealth.comment.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.skinHealth.comment.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.comment.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.health.score.bar">
          Skin Health Score Bar
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range">
            Rate Range
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <div className="d-flex flex-wrap align-items-center">
            <span>0</span>
            <label
              htmlFor={`skincareHtmlResult.skinHealth.score.avgLowerBound`}
              style={rangeStyle}
            >
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.not.good">
                Fair
              </Trans>
            </label>
            <Field name={`skincareHtmlResult.skinHealth.score.avgLowerBound`}>
              {props => (
                <InputBox
                  {...props}
                  containerClassname=" "
                  style={{width: '70px'}}
                  type="number"
                  max={99}
                  min={1}
                  onBlur={val => {
                    if (
                      !isSkinHealthScoreValid(formikProps.values, 'lower', val)
                    ) {
                      toast.error(
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.lower.bound.error">
                          Score rate range average lower bound must be less than
                          average upper bound.
                        </Trans>
                      );
                    }
                  }}
                />
              )}
            </Field>
            <label
              htmlFor={`skincareHtmlResult.skinHealth.score.avgUpperBound`}
              style={rangeStyle}
            >
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.average">
                Average
              </Trans>
            </label>
            <Field name={`skincareHtmlResult.skinHealth.score.avgUpperBound`}>
              {props => (
                <InputBox
                  {...props}
                  style={{width: '70px'}}
                  type="number"
                  max={99}
                  min={1}
                  onBlur={val => {
                    if (
                      !isSkinHealthScoreValid(formikProps.values, 'upper', val)
                    ) {
                      toast.error(
                        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.upper.bound.error">
                          Score rate range average upper bound must be greater
                          than average lower bound.
                        </Trans>
                      );
                    }
                  }}
                />
              )}
            </Field>
            <div style={rangeStyle}>
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.good">
                Good
              </Trans>
            </div>
            100
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color">
            Bar Color
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <div className="form-group row">
            <div>
              <div className="d-flex align-items-center kt-margin-b-10">
                <div style={{width: '70px'}} />
                <div
                  className="text-default text-center"
                  style={{width: '180px', marginRight: '10px'}}
                >
                  <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.left">
                    Left
                  </Trans>
                </div>
                <div
                  className="text-default text-center"
                  style={{width: '180px'}}
                >
                  <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.right">
                    Right
                  </Trans>
                </div>
              </div>
              {scoreRanges(1).map(range => (
                <div
                  key={range.value}
                  className="d-flex align-items-center kt-margin-b-10"
                >
                  <label
                    className="kt-margin-r-10 text-right"
                    style={{width: '70px'}}
                  >
                    {range.label}
                  </label>
                  <div className="kt-margin-r-10">
                    <Field
                      name={`skincareHtmlResult.skinHealth.score.barColors.${
                        range.key
                      }[0]`}
                      component={ColorField}
                    />
                  </div>
                  <div>
                    <Field
                      name={`skincareHtmlResult.skinHealth.score.barColors.${
                        range.key
                      }[1]`}
                      component={ColorField}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.score.trackColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.score.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.summary">
          Summary
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.skinHealth.summary.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.skinHealth.summary.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.summary.titleTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.summary.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.content.text.color">
            Content Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.skinHealth.summary.contentTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.content">
            Content
          </Trans>
        </label>
        <div className="col-4">
          <Select
            options={langUtils.getAppLangList()}
            onChange={o => {
              formikProps.setFieldValue(
                'skincareHtmlResult.skinHealth.summary.contentLanguage',
                o
              );
            }}
            value={_get(
              formikProps.values,
              'skincareHtmlResult.skinHealth.summary.contentLanguage'
            )}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-2 col-lg-3 col-md-3 col-form-label text-right" />
        <div className="col-10  col-lg-9 col-md-9">
          {scoreRanges(1).map(range => (
            <div
              key={range.value}
              className="d-flex align-items-center kt-margin-b-10"
            >
              <label
                className="kt-margin-r-10 text-right"
                style={{width: '60px'}}
              >
                {range.label}
              </label>
              <div style={{width: '100%'}}>
                <Field
                  name={`skincareHtmlResult.skinHealth.summary.contentI18n.${_get(
                    formikProps.values,
                    'skincareHtmlResult.skinHealth.summary.contentLanguage.value'
                  )}.${range.key}`}
                  component={TextareaBox}
                  style={{width: '100%'}}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.detection.category.radar">
          Skin Detection Category Radar
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.radarChart.indicatorTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.score.text.color">
            Score Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.radarChart.scoreTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.radar.chart.color">
            Radar Chart Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.radarChart.color"
            component={ColorField}
          />
        </div>
      </div>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.detection.category.board">
          Skin Detection Category Board
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.detection.board">
          Skin Detection Board
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.board.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.border.color">
            Border Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.board.borderColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.title.text.color">
            Title Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.board.titleTextColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.detection.comment">
          Skin Detection Comment
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.detection.comment.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.detection.comment.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.comment.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.detection.score.bar">
          Skin Detection Score Bar
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range">
            Rate Range
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <div className="d-flex flex-wrap align-items-center">
            <span>0</span>
            <label
              htmlFor={`skincareHtmlResult.detection.score.avgLowerBound`}
              style={rangeStyle}
            >
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.not.good">
                Fair
              </Trans>
            </label>
            <Field name={`skincareHtmlResult.detection.score.avgLowerBound`}>
              {props => (
                <InputBox
                  {...props}
                  containerClassname=" "
                  style={{width: '70px'}}
                  type="number"
                  max={99}
                  min={1}
                />
              )}
            </Field>
            <label
              htmlFor={`skincareHtmlResult.detection.score.avgUpperBound`}
              style={rangeStyle}
            >
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.average">
                Average
              </Trans>
            </label>
            <Field name={`skincareHtmlResult.detection.score.avgUpperBound`}>
              {props => (
                <InputBox
                  {...props}
                  style={{width: '70px'}}
                  type="number"
                  max={99}
                  min={1}
                />
              )}
            </Field>
            <div style={rangeStyle}>
              <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.good">
                Good
              </Trans>
            </div>
            100
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color">
            Bar Color
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <div className="form-group row">
            <div>
              <div className="d-flex align-items-center kt-margin-b-10">
                <div style={{width: '70px'}} />
                <div
                  className="text-default text-center"
                  style={{width: '180px', marginRight: '10px'}}
                >
                  <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.left">
                    Left
                  </Trans>
                </div>
                <div
                  className="text-default text-center"
                  style={{width: '180px'}}
                >
                  <Trans i18nKey="p.s.uiconfiguration.skinresultpage.bar.color.right">
                    Right
                  </Trans>
                </div>
              </div>
              {scoreRanges(1).map(range => (
                <div
                  key={range.value}
                  className="d-flex align-items-center kt-margin-b-10"
                >
                  <label
                    className="kt-margin-r-10 text-right"
                    style={{width: '70px'}}
                  >
                    {range.label}
                  </label>
                  <div className="kt-margin-r-10">
                    <Field
                      name={`skincareHtmlResult.detection.score.barColors.${
                        range.key
                      }[0]`}
                      component={ColorField}
                    />
                  </div>
                  <div>
                    <Field
                      name={`skincareHtmlResult.detection.score.barColors.${
                        range.key
                      }[1]`}
                      component={ColorField}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.score.trackColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.text.color">
            Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.score.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <h6 className="kt-margin-t-10">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.skin.detection.description">
          Skin Detection Description
        </Trans>
      </h6>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.show">
            Show
          </Trans>
        </label>
        <div className="col-9 col-lg-8 col-md-8">
          <Field
            name="skincareHtmlResult.detection.description.enable"
            value={_get(
              formikProps.values,
              'skincareHtmlResult.detection.description.enable'
            )}
            component={CustomSwitch}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.content.text.color">
            Content Text Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.description.textColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.background.color">
            Background Color
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.description.backgroundColor"
            component={ColorField}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.detection.category">
            Detection Category
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Field
            name="skincareHtmlResult.detection.description.categories"
            options={categories}
            isSearchable={true}
            component={SelectBox}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.content">
            Content
          </Trans>
        </label>
        <div className={width >= 1366 ? 'col-4' : 'col-8'}>
          <Select
            options={langUtils.getAppLangList()}
            onChange={o => {
              formikProps.setFieldValue(
                'skincareHtmlResult.detection.description.language',
                o
              );
            }}
            value={_get(
              formikProps.values,
              'skincareHtmlResult.detection.description.language'
            )}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-2 col-lg-3 col-md-3 col-form-label text-right" />
        <div className="col-10 col-lg-9 col-md-9">
          {scoreRanges(1).map(range => (
            <div
              key={range.value}
              className="d-flex align-items-center kt-margin-b-10"
            >
              <label
                className="kt-margin-r-10 text-right"
                style={{width: '60px'}}
              >
                {range.label}
              </label>
              <div style={{width: '100%'}}>
                <Field
                  name={`skincareHtmlResult.detection.description.i18n.${_get(
                    formikProps.values,
                    'skincareHtmlResult.detection.description.language.value'
                  )}.${_get(
                    formikProps.values,
                    'skincareHtmlResult.detection.description.categories'
                  )}.${range.key}`}
                  component={TextareaBox}
                  style={{width: '100%'}}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
